import React from 'react';
import PropTypes from 'prop-types';
import './style.css';
import Button from 'new-ui/Components/Button';

const StatusButton = ({ onClick, title }) => (
  <Button
    backgroundColor="#213332"
    color="#FFF"
    width="100%"
    className="status-btn"
    title={title}
    action={onClick}
  />
);

StatusButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default StatusButton;
